import React, { Component } from 'react';

class ContentPopper extends Component {
  render() {
    return (
      <div id={this.props.name+"Wrapper"}>
        <div id={this.props.name} className={this.props.name+" ContentPopper"}>
        </div>
        <div id={this.props.name+"ContentWrapper"} className="ContentWrapper">
          <h1>{this.props.header}</h1>
          <p>Yapım aşamasında...</p>
        </div>
      </div>
    );
  }
}

export default ContentPopper;



// WEBPACK FOOTER //
// ./src/components/Poppers/ContentPopper.js